import { render } from "./STRCopyright.vue?vue&type=template&id=e1cbcc72"
import script from "./STRCopyright.vue?vue&type=script&lang=js"
export * from "./STRCopyright.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__